import { render, staticRenderFns } from "./data-records-summary-widget.vue?vue&type=template&id=d9fdb5bc&scoped=true"
import script from "./data-records-summary-widget.vue?vue&type=script&lang=js"
export * from "./data-records-summary-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fdb5bc",
  null
  
)

export default component.exports